const LOOKUP_URL = '/api/lookup.php';

export interface VinManager {
  bitrix_id: number;
  name?: string | null;
}

export type VinData = string | Record<string, unknown>;

export interface VinSuccess {
  ok: true;
  vin: string;
  manager: VinManager | null;
  data: VinData | null;
  /** true — менеджеру отправлено уведомление; false — отправка не удалась; null — менеджера в ответе 1С не было. */
  notified: boolean | null;
}

export interface VinFailure {
  ok: false;
  error: { code: string; message: string };
}

export type VinResult = VinSuccess | VinFailure;

export async function lookupVin(vin: string, initData: string): Promise<VinResult> {
  const res = await fetch(LOOKUP_URL, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ vin, initData }),
  });
  return (await res.json()) as VinResult;
}
